shadow$provide[311] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Shader:{enumerable:true, get:function() {
  return Shader;
}}});
var UGLSL = require("../../../util/glsl.js");
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Shader extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "bind", "shader"];
    this.freeform = true;
  }
  init() {
    return this.shader = null;
  }
  make() {
    const {language, code} = this.props;
    if (language !== "glsl") {
      throw new Error("GLSL required");
    }
    this._helpers.bind.make([{to:"shader.sources", trait:"source", multiple:true},]);
    const snippet = this._shaders.fetch(code);
    const types = this._types;
    const uniforms = {};
    const make = type => {
      let t;
      switch(type) {
        case "i":
          return types.int();
        case "f":
          return types.number();
        case "v2":
          return types.vec2();
        case "v3":
          return types.vec3();
        case "v4":
          return types.vec4();
        case "m3":
          return types.mat3();
        case "m4":
          return types.mat4();
        case "t":
          return types.object();
        default:
          t = type.split("");
          if (t.pop() === "v") {
            return types.array(make(t.join("")));
          } else {
            return null;
          }
      }
    };
    for (const def of Array.from(snippet._signatures.uniform)) {
      let type;
      if (type = make(def.type)) {
        uniforms[def.name] = type;
      }
    }
    return this.reconfigure({props:{uniform:uniforms}});
  }
  made() {
    return this.trigger({type:"source.rebuild",});
  }
  unmake() {
    return this.shader = null;
  }
  change(changed, _touched, _init) {
    if (changed["shader.uniforms"] || changed["shader.code"] || changed["shader.language"]) {
      return this.rebuild();
    }
  }
  shaderBind(uniforms) {
    let k, u, v;
    if (uniforms == null) {
      uniforms = {};
    }
    const {code, indices, channels} = this.props;
    for (k in this.node.attributes) {
      v = this.node.attributes[k];
      if (v.type != null && v.short != null && v.ns === "uniform") {
        if (uniforms[v.short] == null) {
          uniforms[v.short] = v;
        }
      }
    }
    if ((u = this.props.uniforms) != null) {
      for (k in u) {
        v = u[k];
        uniforms[k] = v;
      }
    }
    const s = this._shaders.shader();
    if (this.bind.sources != null) {
      for (const source of Array.from(this.bind.sources)) {
        s.callback();
        if (indices != 4) {
          s.pipe(UGLSL.extendVec(indices, 4));
        }
        s.pipe(source.sourceShader(this._shaders.shader()));
        if (channels != 4) {
          s.pipe(UGLSL.truncateVec(4, channels));
        }
        s.join();
      }
    }
    return s.pipe(code, uniforms);
  }
}
Shader.initClass();

};